import { ErrorFallback } from '@src/components/utils';
import type { AuthenticationContextValue } from '@src/context/AuthenticationContext';
import type { APIClient } from '@src/corelib/api/client';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { ReactNode } from 'react';

interface RouterContext {
  auth: AuthenticationContextValue;
  apiClient: APIClient;
}

const component = () => <Outlet />;
const errorComponent = () => <ErrorFallback />;
const notFoundComponent = () => {
  return (
    <div>
      <p>This is the notFoundComponent configured on root route</p>
    </div>
  );
};

const options: {
  component: () => ReactNode;
  notFoundComponent: () => ReactNode;
  errorComponent?: () => ReactNode;
} = {
  component,
  notFoundComponent,
};

if (import.meta.env.MODE === 'production') {
  options.errorComponent = errorComponent;
}

export const Route = createRootRouteWithContext<RouterContext>()(options);
